<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :data="data"/>
        <Items :data="data" :items="data.Items"/>
        <Total :data="data"/>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../StclInfo.js";
import Model from "../StclModel.js";
import Services from "../../../services/Api/StockClosingServices.js";

import Details from "./StclD_Details.vue";
import Items from "./StclD_Items.vue";
import Total from "./StclD_Total.vue";

export default {
  components: {
    Details,
    Items,
    Total
  },
  data: () => ({
    actions: [],
    data: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    },
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
      Model.setDetailsBySpecialPrice(this.data, data.SpecialPriceCount);

      for (const item of this.data.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData(id) {
      this.access = this.$kst.Access.create(Model.Access);
      this.data = {};

      // actions
      const urlParams = this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: id
      });

      this.actions = this.$kst.Access.getAvailableActions(
        Model.Actions.Details, Model.Module, urlParams, this.access
      );
    }
  }
}
</script>